import Hero from '@/app/components/homepage/hero/hero';
import Values from '@/app/components/homepage/values/values';

export default function Homepage() {
  return (
    <>
      <Hero />
      <Values />
    </>
  );
}
